import {Component, Input, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-optional-income-fields',
  templateUrl: './optional-income-fields.component.html',
  styleUrl: './optional-income-fields.component.scss',
  standalone: false
})
export class OptionalIncomeFieldsComponent {
  @Input() fieldsLabel = 'Przychody';
  @Input() amountLabel = 'Netto';
  @Input() resultLabel = 'VAT';
  @Input() initialAmount = null;
  @Input() initialResult = null;
  @Input() placeholder = '';


  amount = 0;
  calculated = null;
  checked = false;

  ngOnInit() {
    this.amount = this.initialAmount;
    this.calculated = this.initialResult;
    // this.recalculate();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.initialAmount || this.initialResult) {
      this.checked = true;
    }
  }
}
